import { Tool } from '../../types';

export const ecommerceTools: Tool[] = [
  {
    id: 'shopify',
    name: 'Shopify',
    category: 'E-commerce',
    description: 'All-in-one e-commerce platform powering over 4 million online stores worldwide. Build your store with beautiful themes, manage inventory, process payments, and fulfill orders. Includes POS for retail, marketing tools, and extensive app marketplace.',
    pricing: ['low', 'medium', 'high'],
    features: ['ease-of-use', 'mobile', 'integrations', 'security', 'scalability'],
    bestFor: ['small-business', 'startup'],
    compatibleWith: ['e-commerce', 'retail', 'marketplace'],
    goals: ['increase-sales', 'streamline-operations', 'expand-customer-base'],
    industries: ['retail', 'creative', 'technology'],
    website: 'https://shopify.pxf.io/o4qxXb',
    imageUrl: 'https://logo.clearbit.com/shopify.com',
    idealStages: ['launching', 'growing', 'scaling'],
    technicalLevel: ['beginner', 'intermediate'],
    minTeamSize: 'solo'
  },
  {
    id: 'woocommerce',
    name: 'WooCommerce',
    category: 'E-commerce',
    description: 'The most popular open-source e-commerce solution, powering 28% of all online stores. Fully customizable WordPress plugin with complete control over your store. Thousands of extensions available for payments, shipping, and marketing.',
    pricing: ['free', 'low'],
    features: ['ease-of-use', 'integrations', 'scalability'],
    bestFor: ['small-business', 'freelancer'],
    compatibleWith: ['e-commerce', 'content-creator'],
    goals: ['increase-sales', 'reduce-costs'],
    industries: ['retail', 'creative'],
    website: 'https://woocommerce.com',
    imageUrl: 'https://logo.clearbit.com/woocommerce.com',
    idealStages: ['launching', 'growing'],
    technicalLevel: ['intermediate', 'advanced'],
    minTeamSize: 'solo'
  }
];